import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA42NggbkzzNagezm8ULFnNO5WQHS476iQ",
  authDomain: "gorkha-police.firebaseapp.com",
  projectId: "gorkha-police",
  storageBucket: "gorkha-police.firebasestorage.app",
  messagingSenderId: "133006966245",
  appId: "1:133006966245:web:b34f2b34ac2a38344d430c",
  measurementId: "G-RZRQK8TD6R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };